import React from 'react'

function DeleteForever(props) {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="15.434"
         height="18.578"
         viewBox="0 0 15.434 18.578"
         {...props}
      >
         <path
            fill={props.color}
            d="M164.847-826.041l2.87-3.122 2.894 3.122 1.133-1.239-2.87-3.122 2.87-3.122-1.133-1.239-2.894 3.122-2.87-3.122-1.158 1.239 2.894 3.122-2.894 3.122zm-2.411 4.619a1.346 1.346 0 01-1.013-.464 1.537 1.537 0 01-.434-1.084v-14.708H160v-1.548h4.534V-840h6.366v.774h4.534v1.548h-.989v14.708a1.537 1.537 0 01-.434 1.084 1.346 1.346 0 01-1.013.464zM173-837.678h-10.564v14.708H173zm-10.562 0z"
            transform="translate(-160 840)"
         ></path>
      </svg>
   )
}

export default DeleteForever
